module.exports = __webpack_public_path__ + "img/loading.fa69e25.svg";